<template>
  <div class="track-card card" :class="{ readonly: readonly }">
    <div class="card-bd">
      <div class="track-hd">
        <span class="track-icon risk">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 3" />
          </svg>
        </span>
        <div>
          <h4>风控审核环 · 开票经济 / 价格 / 货物合规</h4>
          <p>终审环节，拥有一票否决权</p>
        </div>
        <el-tag
          v-if="!readonly"
          size="mini"
          type="primary"
          effect="plain"
          style="margin-left:auto;background:rgba(124,58,237,0.1);color:#7c3aed;border-color:rgba(124,58,237,0.2)"
        >您的审核轨</el-tag>
      </div>

      <template v-if="status === 'RISK'">
        <div class="score-row">
          <span class="score-label">开票经济风险（8 维评分卡）</span><span
            class="score-desc"
          >成立时长、实缴、地址一致性、佐证充分性均低险</span><span class="score-tag low">12 分 · 低</span>
        </div>
        <div class="score-row">
          <span class="score-label">签约价格合规</span><span
            class="score-desc"
          >费率 {{ (ddData && ddData.feeRate) || "--" }}%，在 5%-8%
            区间内</span><span class="score-tag low">低</span>
        </div>
        <div class="score-row">
          <span class="score-label">常发货物合规</span><span
            class="score-desc"
          >{{ (ddData && ddData.commonCargo) || "--" }} · 非禁限运品类</span><span class="score-tag low">低</span>
        </div>
        <div class="score-total">
          <span class="total-num">12<span class="total-max">/100</span></span>
          <div>
            <div class="total-label">低风险 · 真实运输需求企业</div>
            <div class="total-hint">
              ≤30 低风险 · 31-60 补材料 · >60 默认驳回
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="status === 'RUN'">
        <div class="audit-rec ok">
          <span class="ar-dot">✓</span>
          <div>
            <b>已通过</b> · 风控审核<span
              class="ar-meta"
            >费率在指导区间内，开票经济风险低，确认签约主体与授信额度</span>
          </div>
        </div>
        <div class="ar-sub">
          企业状态已流转「待签约」，签约邀请短信已发托运人业务负责人
        </div>
      </template>

      <template v-else-if="status === 'FIX' && isDdFix">
        <div class="audit-rec err">
          <span class="ar-dot">↩</span>
          <div>
            <b>已退回市场端整改</b> · 风控审核<span
              class="ar-meta"
            >尽调材料不足，历史发货佐证无法验证月均发货规模</span>
          </div>
        </div>
        <div class="ar-sub">
          退回原因已同步客户经理，整改重提后从客服审核环节重新流转
        </div>
      </template>

      <template v-else>
        <div class="stage-lock">
          <b>待开启</b>客服审核通过后自动进入本环节，流转时站内消息提醒
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "RiskTrack",
  props: {
    applyCode: { type: String, default: "" },
    readonly: { type: Boolean, default: false },
    ddData: { type: Object, default: null },
    status: { type: String, default: "" }
  },
  computed: {
    isDdFix() {
      return this.status === "FIX" && this.ddData;
    }
  }
};
</script>

<style lang="scss" scoped>
.track-card {
  &.readonly {
    opacity: 0.6;
    pointer-events: none;
  }
  .card-bd {
    padding: 14px;
  }
  .track-hd {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--line2);
    margin-bottom: 14px;
  }
  .track-hd h4 {
    font-size: 14px;
    font-weight: 700;
    margin: 0;
    color: var(--ink);
  }
  .track-hd p {
    font-size: 12px;
    color: var(--ink3);
    margin: 2px 0 0;
  }
  .track-icon {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .track-icon.risk {
    background: rgba(124, 58, 237, 0.1);
    color: #7c3aed;
  }
  .score-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px dashed var(--line2);
    font-size: 12.5px;
    flex-wrap: wrap;
  }
  .score-row .score-label {
    flex: 1;
    color: var(--ink2);
    font-weight: 500;
    min-width: 120px;
  }
  .score-row .score-desc {
    color: var(--ink3);
    font-size: 11px;
    max-width: 48%;
    text-align: right;
  }
  .score-tag {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 5px;
    flex-shrink: 0;
  }
  .score-tag.low {
    background: var(--ok-bg);
    color: #065f46;
  }
  .score-total {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
    padding: 12px 14px;
    border-radius: var(--r);
    background: var(--ok-bg);
    border: 1px solid #a7f3d0;
  }
  .score-total .total-num {
    font-size: 22px;
    font-weight: 800;
    color: #065f46;
    font-family: "SF Mono", "JetBrains Mono", ui-monospace, Menlo, Consolas,
      "Liberation Mono", monospace;
    font-variant-numeric: tabular-nums;
  }
  .score-total .total-max {
    font-size: 11px;
    color: var(--ink3);
    font-weight: 500;
  }
  .score-total .total-label {
    font-size: 12px;
    font-weight: 700;
    color: #065f46;
  }
  .score-total .total-hint {
    font-size: 11px;
    color: var(--ink4);
    margin-top: 2px;
  }
  .audit-rec {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    border-radius: 10px;
    padding: 11px 13px;
    font-size: 12.5px;
    line-height: 1.65;
    margin-bottom: 12px;
  }
  .audit-rec.ok {
    background: #fbfffd;
    border: 1px solid #bfe3d6;
  }
  .audit-rec.err {
    background: #fffafa;
    border: 1px solid #ffccc7;
  }
  .ar-dot {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 700;
  }
  .audit-rec.ok .ar-dot {
    background: #10b981;
    color: #fff;
  }
  .audit-rec.err .ar-dot {
    background: #ef4444;
    color: #fff;
  }
  .ar-meta {
    display: block;
    color: #94a3b8;
    font-size: 11px;
    font-weight: 400;
    margin-top: 2px;
  }
  .ar-sub {
    font-size: 10px;
    color: #94a3b8;
  }
  .stage-lock {
    border: 1.5px dashed #e2e8f0;
    border-radius: 11px;
    padding: 22px 16px;
    text-align: center;
    color: #94a3b8;
    font-size: 12.5px;
    background: #fafbfc;
  }
  .stage-lock b {
    display: block;
    font-size: 13px;
    color: #64748b;
    margin-bottom: 5px;
  }
}
</style>
